'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Avatar, Typography, Chip, useTheme, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSponsorshipProfileStyles } from './useSponsorshipProfileStyles';
const SponsorshipProfile = ({ sponsorship }) => {
    const theme = useTheme();
    const styles = useSponsorshipProfileStyles();
    const { t } = useTranslation();
    const getStatusColor = (status) => {
        switch (status) {
            case 'Active':
            case 'Linked':
                return 'info';
            case 'Inactive':
            case 'Not Linked':
                return 'default';
            case 'Pending':
                return 'warning';
            case 'Expired':
                return 'error';
            case 'Cancelled':
                return 'default';
            default:
                return 'default';
        }
    };
    const getStatusLabel = (status) => {
        switch (status) {
            case 'Active':
                return t('common.active');
            case 'Inactive':
                return t('common.inactive');
            case 'Linked':
                return t('common.linked');
            case 'Not Linked':
                return t('common.notLinked');
            default:
                return status;
        }
    };
    return (_jsxs(Box, { sx: styles.container, children: [_jsxs(Box, { sx: {
                    position: 'relative',
                    width: '100%',
                    height: 200,
                    borderRadius: '12px 12px 0 0',
                    ...styles.profileBackground
                }, children: [_jsx(Box, { component: 'img', src: '/assets/images/sponsorship-details-bg.png', alt: 'Background', sx: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        } }), _jsx(Box, { component: 'img', src: '/assets/images/layer.svg', alt: 'Curve', sx: {
                            position: 'absolute',
                            bottom: -10,
                            pointerEvents: 'none'
                        } }), _jsx(Box, { sx: {
                            position: 'absolute',
                            left: '50%',
                            bottom: '-16px',
                            transform: 'translateX(-50%)'
                        }, children: _jsx(Avatar, { sx: {
                                width: 64,
                                height: 64,
                                color: theme.palette.action.active,
                                backgroundColor: theme.palette.background.default,
                                border: `3px solid ${theme.palette.background.paper}`
                            }, alt: sponsorship.partnerName, src: sponsorship.partnerLogo, children: sponsorship.partnerName.charAt(0) }) })] }), _jsxs(Box, { sx: { display: 'flex', py: theme.spacing(3), gap: 0, width: '100%', alignItems: 'center' }, children: [_jsxs(Box, { display: 'flex', paddingX: theme.spacing(2), gap: 0.5, alignItems: 'center', flex: 1, minWidth: 0, children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1, minWidth: 0, children: [_jsx(Typography, { variant: 'h5', children: sponsorship.partnerName }), _jsx(Typography, { variant: 'body2', color: 'text.secondary', children: sponsorship.sponsorshipType })] }), _jsx(Box, { sx: { flexShrink: 0 }, children: _jsx(Chip, { variant: 'soft', label: getStatusLabel(sponsorship.status), color: getStatusColor(sponsorship.status), size: 'small', sx: { height: 24, ml: 2, mt: 0.5 } }) })] }), _jsx(Divider, { orientation: 'vertical', sx: { mx: 2, color: theme.palette.divider, height: 72 } }), _jsxs(Box, { display: 'flex', paddingX: theme.spacing(2), paddingY: theme.spacing(1), gap: 1, alignItems: 'flex-start', borderRadius: 2, flex: 1, minWidth: 0, children: [_jsx(Avatar, { src: sponsorship.contactPerson.avatar, variant: 'rounded', sx: { width: 48, height: 48, flexShrink: 0, borderRadius: '12px' }, children: sponsorship.contactPerson.name.charAt(0) }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minWidth: 0, children: [_jsx(Typography, { variant: 'subtitle2', color: 'text.secondary', children: t('sponsorships.contactPerson') }), _jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', children: _jsx(Typography, { variant: 'subtitle1', flex: 1, fontWeight: 500, noWrap: true, color: 'text.primary', children: sponsorship.contactPerson.name }) })] })] })] })] }));
};
export default SponsorshipProfile;
